// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_EstornarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combos/estornar (NS 2026-0090, fatia 5).
 *
 * Estorna UM consumo do razao do combo: +1 par disponivel. O consumo fica;
 * o estorno aponta para ele. Full/Franqueado/Gerente.
 *
 * JSON body:
 * {
 *   "movement_id": 81,          // so_combo_movements PK de um `consumo`, required
 *   "motivo": "Par refeito"     // required, nao vazio
 * }
 */
import { registerContract } from './validate'

export interface Combos_EstornarInput {
movement_id: number
motivo: string
}

registerContract('Combos_EstornarInput', {
  movement_id: { type: 'number',  required: true },
  motivo:      { type: 'string',  required: true },
})
